import "styles/breakdownSubsection.less";

import React, { useContext } from "react";

import { Typography } from "antd";
import { AppContext } from "App";

interface BreakdownSubsectionProps {
    subsectionName: string;
    currentYearAmount: number;
    previousYearAmount: number;
    isBold: boolean;
    hasLargeMargin: boolean;
    isTotalDifference: boolean;
}

const BreakdownSubsection: React.FC<BreakdownSubsectionProps> = ({ subsectionName, currentYearAmount, previousYearAmount, isBold, hasLargeMargin, isTotalDifference }) => {
    const { isMobile } = useContext(AppContext);
    return (
        <div style={{ display: "flex" }}>
            <div className={isMobile ? "breakdown-subsection__title-container-mobile" : hasLargeMargin ? "breakdown-subsection__large-margin-container-desktop" : "breakdown-subsection__title-container-desktop" }>
                <Typography className={isBold ? "breakdown-subsection__total-liability-text" : isTotalDifference ? "breakdown-subsection__green-text" : "breakdown-subsection__text"}>
                    { subsectionName }
                </Typography>
            </div>
            <div className={isMobile ? "breakdown-subsection__amounts-container-mobile" : "breakdown-subsection__amounts-container-desktop"} style={isMobile ? { alignSelf: "center" } : {}}>
                <div className={isMobile ? "breakdown-subsection__tax-year-amount-mobile" : "breakdown-subsection__tax-year-amount-desktop"}>
                    <Typography className={isBold ? "breakdown-subsection__total-liability-text" : isTotalDifference ? "breakdown-subsection__green-text" : "breakdown-subsection__amount-text"}>
                        {isTotalDifference ? "" : `£${currentYearAmount}`}
                    </Typography>
                </div>
                <div className={isMobile ? "breakdown-subsection__tax-year-amount-mobile" : "breakdown-subsection__tax-year-amount-desktop"}>
                    <Typography className={isBold ? "breakdown-subsection__total-liability-text" : isTotalDifference ? "breakdown-subsection__green-text" : "breakdown-subsection__amount-text"}>
                        £{previousYearAmount}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default BreakdownSubsection;
